import { render, staticRenderFns } from "./SolutionEdit.vue?vue&type=template&id=25636d14&scoped=true&"
import script from "./SolutionEdit.vue?vue&type=script&lang=js&"
export * from "./SolutionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25636d14",
  null
  
)

export default component.exports